module.exports = __webpack_public_path__ + "img/vorne tag.25846b53.jpg";